import { ReactNode } from 'react'
import { lightTheme } from '@/customTheme'
import TitleWithSubAction from '@/components/TitleWithSubAction/TitleWithSubAction'
import HorizontalScroller from '@/components/HorizontalScroller'

// Shared section-title style so every dashboard header (Try Templates / AI tools /
// Recent projects) reads identically.
export const DASHBOARD_SECTION_TITLE_STYLE = { ...lightTheme.typography.Header20bold, fontWeight: 600 }

interface SectionRowProps {
  title: string
  onSeeAll?: () => void
  seeAllLabel?: string
  gap?: number
  arrowVerticalPosition?: number | 'center'
  /** Fixed card height for the row; cards stretch to it and size their width from it. */
  itemHeight?: number
  children: ReactNode
}

/**
 * A dashboard section = a title (with an optional "See all" action) above a
 * horizontal scroller. Removes the header + scroller boilerplate every section
 * used to hand-roll.
 */
function SectionRow({
  title,
  onSeeAll,
  seeAllLabel = 'See all',
  gap = 24,
  arrowVerticalPosition = 'center',
  itemHeight,
  children,
}: SectionRowProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <TitleWithSubAction
        title={title}
        subActionText={seeAllLabel}
        onSubActionClick={onSeeAll}
        titleStyle={DASHBOARD_SECTION_TITLE_STYLE}
        containerStyle={{ marginBottom: '14px' }}
      />
      <HorizontalScroller
        gap={gap}
        itemHeight={itemHeight}
        arrowVerticalPosition={arrowVerticalPosition}
        arrowButtonSize="large"
        arrowIconVariant="line"
        contentAlign="start"
        arrowPlacement="edge"
        arrowVisibility="always"
        edgeClearance="full"
        showFadeMask={false}
        pageScroll
        edgeBounce
      >
        {children}
      </HorizontalScroller>
    </div>
  )
}

export default SectionRow
